/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface FormateurSuiviFichierUploadDto
 */
export interface FormateurSuiviFichierUploadDto {
    /**
     * 
     * @type {FileUploadDto}
     * @memberof FormateurSuiviFichierUploadDto
     */
    file?: FileUploadDto;
    /**
     * 
     * @type {number}
     * @memberof FormateurSuiviFichierUploadDto
     */
    idformateurSuiviFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof FormateurSuiviFichierUploadDto
     */
    idformateurSuivi?: number;
    /**
     * 
     * @type {number}
     * @memberof FormateurSuiviFichierUploadDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof FormateurSuiviFichierUploadDto
     */
    idtypeSuiviFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof FormateurSuiviFichierUploadDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the FormateurSuiviFichierUploadDto interface.
 */
export function instanceOfFormateurSuiviFichierUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurSuiviFichierUploadDtoFromJSON(json: any): FormateurSuiviFichierUploadDto {
    return FormateurSuiviFichierUploadDtoFromJSONTyped(json, false);
}

export function FormateurSuiviFichierUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurSuiviFichierUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : FileUploadDtoFromJSON(json['file']),
        'idformateurSuiviFichier': !exists(json, 'idformateurSuiviFichier') ? undefined : json['idformateurSuiviFichier'],
        'idformateurSuivi': !exists(json, 'idformateurSuivi') ? undefined : json['idformateurSuivi'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeSuiviFichier': !exists(json, 'idtypeSuiviFichier') ? undefined : json['idtypeSuiviFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function FormateurSuiviFichierUploadDtoToJSON(value?: FormateurSuiviFichierUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FileUploadDtoToJSON(value.file),
        'idformateurSuiviFichier': value.idformateurSuiviFichier,
        'idformateurSuivi': value.idformateurSuivi,
        'idfichier': value.idfichier,
        'idtypeSuiviFichier': value.idtypeSuiviFichier,
        'fileName': value.fileName,
    };
}

